import React from 'react';
import { linkStyle } from './styles';

const Link = ({ onClick, style, children }) => (
    <a
        href="#"
        style={style ? { ...linkStyle, ...style } : linkStyle}
        onClick={(e) => {
            e.preventDefault();
            onClick();
        }}
    >
        {children}
    </a>
);

export default Link;
